import React, { useState, useEffect } from 'react';
import { supabase } from '../supabaseClient';

const RaceEntry = ({ session }) => {
  const [isPaid, setIsPaid] = useState(false);
  const [loading, setLoading] = useState(true);
  const [agreed, setAgreed] = useState(false);

  useEffect(() => {
    if (!session) return;
    
    // Check if the user has already paid in our race_participants table
    const checkStatus = async () => {
      const { data, error } = await supabase
        .from('race_participants')
        .select('*')
        .eq('id', session.user.id)
        .single();
        
      if (data && data.is_paid) {
        setIsPaid(true);
      }
      setLoading(false);
    };

    checkStatus();
  }, [session]);

  const handlePayEntryFee = async () => {
    if (!agreed) {
      alert("You must agree to the Race Rules first!");
      return;
    }

    try {
      // We pass the user ID so the backend knows who is paying!
      const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:4242';
      const response = await fetch(`${apiUrl}/create-race-fee-session`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ userId: session.user.id }),
      });

      const sessionData = await response.json();

      if (sessionData.error) {
        alert("Failed to initiate payment: " + sessionData.error);
        return;
      }

      if (sessionData.url) {
        window.location.href = sessionData.url;
      }
    } catch (error) {
      console.error(error);
      alert("Could not reach backend server to process payment.");
    }
  };

  if (!session) return null; // Hide totally if not a member

  return (
    <div className="card" style={{ padding: '30px', backgroundColor: '#e9f5ff', border: '2px solid #0056b3', marginTop: '30px' }}>
      <h2 style={{ color: '#0056b3', marginTop: 0 }}>⛵ Racer Dashboard</h2>
      
      {loading ? (
        <p>Checking registration status...</p>
      ) : isPaid ? (
        <div style={{ backgroundColor: '#d4edda', padding: '20px', borderRadius: '8px', border: '1px solid #c3e6cb' }}>
          <h3 style={{ color: '#155724', margin: 0 }}>✅ You are officially Registered to Race!</h3>
          <p style={{ color: '#155724', margin: '10px 0 0 0' }}>Your race fees are paid and rules have been acknowledged. See you on the water, {session.user.user_metadata.skipper_name}!</p>
        </div>
      ) : (
        <div>
          <p>You are logged in as a Club Member! To officially enter the regatta, you must pay the entry fee and acknowledge the rules.</p>
          
          <div style={{ margin: '20px 0', padding: '15px', border: '1px solid #ccc', borderRadius: '5px', backgroundColor: '#fff' }}>
            <h4 style={{ margin: '0 0 10px 0' }}>Official Race Rules & Liability</h4>
            <p style={{ fontSize: '12px', color: '#666', height: '60px', overflowY: 'scroll', border: '1px solid #eee', padding: '5px' }}>
              1. All skippers must conform to ISAF Racing Rules.<br/>
              2. Lifejackets must be worn by all crew.<br/>
              3. The regatta organizers are not liable for damage to boats.<br/>
              4. VHF Radio channel 72 MUST be monitored at all times.
            </p>
            <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', marginTop: '10px', fontWeight: 'bold' }}>
              <input 
                type="checkbox" 
                checked={agreed} 
                onChange={(e) => setAgreed(e.target.checked)} 
                style={{ marginRight: '10px', width: '20px', height: '20px' }}
              />
              I have read, downloaded, and agree to the Race Rules.
            </label>
          </div>

          <button 
            onClick={handlePayEntryFee} 
            disabled={!agreed}
            style={{ 
              width: '100%', padding: '15px', fontSize: '18px', fontWeight: 'bold',
              backgroundColor: agreed ? '#28a745' : '#6c757d',
              cursor: agreed ? 'pointer' : 'not-allowed'
            }}
          >
            Pay Race Entry Fee ($150)
          </button>
        </div>
      )}
    </div>
  );
};

export default RaceEntry;
